import { cn } from '@/lib/utils'
import { Base } from '@/ui/components'
import { BaseProps } from '../types'

interface Props extends BaseProps {
  type: 'table' | 'header' | 'row' | 'footer'
  children?: React.ReactNode
  ref?: React.RefObject<HTMLElement>
  variant?: 'default' | 'grey'
  align?: 'left' | 'center' | 'right'
}

const Table = ({
  children,
  className,
  type = 'table',
  align = 'left',
  variant = 'default',
  ref,
  ...props
}: Props) => {
  const tableTypes = cn(
    type === 'table' && 'grid-rows-auto grid auto-rows-auto grid-cols-1',
    (type === 'header' || type === 'row') &&
      'gap-x-6 grid grid-cols-auto auto-cols-auto grid-flow-col',
    type === 'header' && 'border-b-4 border-b-neutral-600 p-4 py-4 font-bold',
    type === 'row' && 'border-b border-b-neutral-600 p-4 py-4'
  )

  const tabelAlign = cn(
    align === 'left' && 'justify-items-start',
    align === 'center' && 'justify-items-center',
    align === 'right' && 'justify-items-end'
  )

  console.log('Table rendered with props:', variant)

  return (
    <Base
      ref={ref}
      className={cn(tableTypes, tabelAlign, className)}
      {...props}
    >
      {children}
    </Base>
  )
}

Table.displayName = 'Table'

export default Table
